import {Chain, CHAIN_NAME_TO_CHAIN_ID} from "api/util";
import { nativeOnChain } from 'constants/tokens'

export function getNativeTokenDBAddress(chain: Chain): string | undefined {
  const pageChainId = CHAIN_NAME_TO_CHAIN_ID[chain]
  if (pageChainId === undefined) {
    return undefined
  }
  switch (chain) {
    case Chain.CRAT:
    case Chain.CRAT_TESTNET:
      return nativeOnChain(pageChainId).wrapped.address
    default:
      return undefined
  }
}
